import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import InitiativeValidations from 'scaleflow/validators/initiative';
import { task } from 'ember-concurrency';

export default class BacklogInitiativesInitiativeSettingsController extends Controller {
  @service('beta-toggle') betaService;
  initiativeValidations = InitiativeValidations;
  @service router;

  @action
  resetForm(changeset, e) {
    e.preventDefault();
    changeset.rollback();
  }

  @action
  setBelongsToRelationships(changeset) {
    const theme = changeset.get('theme');
    const pm = changeset.get('productManager');

    if (theme?.content) {
      changeset.set('theme', theme.content);
    }
    if (pm?.content) {
      changeset.set('productManager', pm.content);
    }
  }

  saveSettings = task({}, async (changeset, e) => {
    //EMber changeset throws an error when trying to save a model with async belongs to relationships
    this.setBelongsToRelationships(changeset);
    e.preventDefault();
    if (changeset.get('isDirty')) {
      this.nothingChanged = false;
      changeset.validate().then(() => {
        if (changeset.get('isValid')) {
          changeset
            .save()
            .then(() => {
              this.submittedOnce = true;
            })
            .catch((err) => {
              console.log(err, 'err');
              changeset
                .get(this, 'model.errors')
                .forEach(({ attribute, message }) => {
                  changeset.addError(attribute, message);
                });
            });
        }
      });
      // if there is an extra action that needs to be done after the form is submitted
    } else {
      this.saveSettings.cancelAll();
    }
  });

  @action
  async deleteInitiative() {
    try {
      this.router.replaceWith('backlog.initiatives');
      this.model.destroyRecord();
    } catch (err) {
      console.log(err);
    }
  }
}
